import { PlayResponse } from '../../types';

// Cash reels: не финальный выигрыш (double)
export const localBonusCashReelsData: PlayResponse = {
    round: 'uid',
    step: 'uid',
    balance: 1461084222196,
    resp: {
        game_type: 'CRAZY_CRAZY_CLAW',
        win: true,
        bonus_game: 'CASH_REELS',
        cash_reels_params: {
            reels: [
                ['2', '4', '10', '20', 'DOUBLE'],
                ['2', '4', '10', '20', 'DOUBLE'],
                ['2', '4', '10', '20', 'DOUBLE']
            ]
        },
        cash_reels_result: {
            sectors: ['DOUBLE', 'DOUBLE', 'DOUBLE']
        },
        final_result: false
    },
    final: false
};
